export enum BurialInterment {
	Mausoleum = 'mausoleum',
	LawnCrypt = 'lawnCrypt',
	GroundBurial = 'groundBurial',
}

export enum CremationInterment {
	Burial = 'burial',
	Niche = 'niche',
	FamilyPickUp = 'familyPickUp',
	Scatter = 'scatter',
}
